<template>
    <d2-container>
            <!--<div slot="header" class="clearfix">
                <span>修改密码</span>
            </div>-->
            <div class="container" v-loading="editDialog.loading" >
                <el-form :model="editDialog.form" @submit.native.prevent :rules="formRules" ref="editForm">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="旧密码" prop="oldPwd" :label-width="editDialog.formLabelWidth">
                                <el-input type="password" v-model="editDialog.form.oldPwd" autocomplete="off" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="新密码" prop="pass" :label-width="editDialog.formLabelWidth">
                                <el-input type="password" v-model="editDialog.form.pass" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="确认密码" prop="checkPass" :label-width="editDialog.formLabelWidth">
                                <el-input type="password" v-model="editDialog.form.checkPass" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="" :label-width="editDialog.formLabelWidth">
                                <el-button type="primary" @click="updatePwd('put')">保 存</el-button>
                                <el-button @click="resetForm('editForm')">重置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
    </d2-container>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: "SystemPwd",
        data(){
            let validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.editDialog.form.checkPass !== '') {
                        this.$refs.editForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            let validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.editDialog.form.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                editDialog: {
                    loading: false,
                    formLabelWidth: '120px',
                    form: {

                    }
                },
                formRules: {
                    oldPwd: [
                        { required: true, message: '这是必填字段', trigger: 'blur' }
                    ],
                    pass: [
                        { required: true, message: '这是必填字段', trigger: 'blur' },
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    checkPass: [
                        { required: true, message: '这是必填字段', trigger: 'blur' },
                        { validator: validatePass2, trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.d2admin.userInfo
            })
        },
        methods: {
            updatePwd(requestMethod){
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        this.editDialog.loading = true
                        let params = {
                            id: this.userInfo.user.id,
                            oldPwd: this.editDialog.form.oldPwd,
                            newPwd: this.editDialog.form.pass
                        }
                        this.$axios({
                            method: requestMethod?requestMethod:this.addDialog.requestMethod,
                            url: '/service/system/sys/security/user/password',
                            data: params
                        }).then(res => {
                            if(res.code == 200){
                                this.$alert(res.message, '成功提示',{
                                    callback: action => {
                                        this.resetForm('editForm')
                                    }
                                })
                            }else{
                                this.$alert(res.message, '失败提示')
                            }
                        }).catch(function (error) {
                            console.log(error)
                        }).then(() => {
                            this.editDialog.loading = false
                        });
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }

    }
</script>

<style scoped>
    .container{
        padding: 20px;
    }
</style>
